export { default } from '@framework/tenant/config/finsight';
